import * as React from "react";
import { Box } from "@twilio/flex-ui/node_modules/@twilio-paste/box";
import { Button } from "@twilio/flex-ui/node_modules/@twilio-paste/core/node_modules/@twilio-paste/button";
import { Spinner } from "@twilio/flex-ui/node_modules/@twilio-paste/core/node_modules/@twilio-paste/spinner";
import { DownloadIcon } from "@twilio/flex-ui/node_modules/@twilio-paste/icons/esm/DownloadIcon";
import generatePdfTranscript from "../utils/generatePdfTranscript";
import { Manager } from "@twilio/flex-ui";
import ExceptionLogger from "../ExceptionHelper";

export class DownloadTranscriptButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            disabled: false
        };
    }

    componentWillUnmount() {
        if (this._timeout) clearTimeout(this._timeout);
    }

    onClick = async () => {
        if (this.state.disabled) return;
        this.setState({ loading: true, disabled: true });

        try {
            const manager = Manager.getInstance();
            // MessageInputV2 passes conversationSid/channelSid directly in props
            const sid = this.props.conversationSid
                || this.props.channelSid
                || (this.props.task && (this.props.task.attributes?.conversationSid || this.props.task.attributes?.channelSid))
                || null;

            const friendlyName = (this.props.task && this.props.task.attributes?.friendlyName)
                || (this.props.conversation && this.props.conversation.friendlyName)
                || null;

            if (!sid) throw new Error('Conversation SID not found');

            await generatePdfTranscript(manager, sid, friendlyName);
        } catch (e) {
            ExceptionLogger(e, "DownloadTranscriptButton.js:onClick", "Error generating transcript", (Manager.getInstance && Manager.getInstance().user && Manager.getInstance().user.token) || "", { conversationSid: this.props?.conversationSid || null });
        } finally {
            // Keep button disabled for 5 seconds to prevent abuse
            this.setState({ loading: false });
            this._timeout = setTimeout(() => this.setState({ disabled: false }), 5000);
        }
    }

    render() {
        // MessageInputV2 does not pass a task prop; instead Flex sets disabledReason to
        // "Conversation ended" when the task enters wrapping state. Use that as the signal.
        const isWrapping = this.props.disabledReason === 'Conversation ended';
        if (!isWrapping) return null;

        try {
            return (
                <Box
                    as="div"
                    display="flex"
                    justifyContent="center"
                    paddingTop="space40"
                    paddingBottom="space40"
                    borderTopStyle="solid"
                    borderTopWidth="borderWidth10"
                    borderTopColor="colorBorderWeaker"
                >
                    <Button
                        variant="secondary"
                        onClick={this.onClick}
                        disabled={this.state.disabled || this.state.loading}
                        data-test="download-transcript-button"
                    >
                        {this.state.loading ? (
                            <>
                                <Spinner decorative={false} title="Loading" />
                                <Box as="span" marginLeft="space20">Loading...</Box>
                            </>
                        ) : (
                            <>
                                <DownloadIcon decorative={true} />
                                <Box as="span" marginLeft="space20">Download Transcript</Box>
                            </>
                        )}
                    </Button>
                </Box>
            );
        } catch (e) {
            ExceptionLogger(e, "DownloadTranscriptButton.js:render", "Error rendering DownloadTranscriptButton", (Manager.getInstance && Manager.getInstance().user && Manager.getInstance().user.token) || "", null);
            return null;
        }
    }
}

export default DownloadTranscriptButton;
